import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IRecorridoDinamico } from 'modelos/src';
import {
  IDetalleCumplimientoDinamico,
  RecorridosDinamicosService,
} from '../../../../../auxiliares/servicios/http/recorridos-dinamicos.service';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';

export interface DetalleCumplimientoPuntosData {
  recorrido: IRecorridoDinamico;
}

@Component({
  selector: 'app-detalle-cumplimiento-puntos',
  templateUrl: './detalle-cumplimiento-puntos.component.html',
  styleUrl: './detalle-cumplimiento-puntos.component.scss',
  standalone: false,
})
export class DetalleCumplimientoPuntosComponent implements OnInit {
  dialogRef =
    inject<MatDialogRef<DetalleCumplimientoPuntosComponent>>(MatDialogRef);
  data = inject<DetalleCumplimientoPuntosData>(MAT_DIALOG_DATA);
  private recorridosDinamicosService = inject(RecorridosDinamicosService);
  private helper = inject(HelperService);

  public loading = false;
  public detalle?: IDetalleCumplimientoDinamico;

  /**
   * El `detalleCumplimiento` que ya trae `data.recorrido` (de la fila del
   * listado) es definitivo: la ventana terminó Y ese cálculo es de después
   * de ese cierre. Mismo criterio que `esCalculoDefinitivo` en
   * RecorridosDinamicosService (backend).
   */
  private get yaEsDefinitivo(): boolean {
    const fechaHasta = this.data.recorrido.ventana?.fechaHasta;
    if (!fechaHasta || fechaHasta > new Date().toISOString()) return false;
    const calculadoEn = this.data.recorrido.detalleCumplimiento?.calculadoEn;
    return !!calculadoEn && calculadoEn >= fechaHasta;
  }

  async ngOnInit(): Promise<void> {
    // Ya tenemos el resultado definitivo en la fila del listado: mostrarlo
    // directo, sin pedirle nada al backend (ni spinner de "Calculando...").
    if (this.yaEsDefinitivo) {
      this.detalle = this.data.recorrido.detalleCumplimiento;
      return;
    }

    this.loading = true;
    try {
      this.detalle = await this.recorridosDinamicosService.getDetallePuntos(
        this.data.recorrido._id!,
      );
    } catch (error) {
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public formatSegundos(segundos: number): string {
    const min = Math.floor(segundos / 60);
    const seg = Math.round(segundos % 60);
    return `${min}m ${seg}s`;
  }
}
